import ShareReport from './ShareReport';

export default ShareReport;
